// extracted by mini-css-extract-plugin
export default {"cls1":"VeloRadioTileGroup-Skeleton_cls1__zPAno","cls2":"VeloRadioTileGroup-Skeleton_cls2__vS6I1 VeloRadioTileGroup-Skeleton_cls1__zPAno"};